//Ini untuk mengubah gambar di semua website!

// 1. Import semua gambar di sini
import funcollect from '../assets/images/1.png';
import complete from '../assets/images/2.png';
import musthave from '../assets/images/3.png';
import prestige from '../assets/images/4.png';

// 2. Export array datanya
export const auctionsData = [
    {
        id: 0,
        // Data Umum
        title: "FUN COLLECT #19",
        date: new Date(2026, 0, 7, 19, 0), // 7 Januari 2026, jam 19.00
        image: funcollect, // Gambar diset disini
        
        // Data Khusus Carousel
        subtitle: "125 Lot Tjiamik🔥",
        featuring: "Jangan sampai kelewatan!!!",
        
        // Data Khusus Upcoming Page
        description: "Fun Collect #19! Koleksi pilihan Numismatik Nusantara dengan kualitas terbaik dan kelangkaan tinggi.",
        status: "UPCOMING",
        highlights: ['Uang Kertas', 'Aneka Koin', 'Aneka barang koleksi'],
        catalogLink: 'https://bid.syailendra-auction.com/auctions/5-277Y6F/syailendra-auction-fun-collect-19',
        termsLink: '/terms'
    },
    {
        id: 1,
        title: "COMPLETE #19",
        date: new Date(2026, 0, 8, 19, 0),
        image: complete,
        
        subtitle: "87 Lot Tjiamik🔥",
        featuring: "Lengkapi koleksimu sekarang!",
        
        description: "Complete #19! Koleksi pilihan Numismatik Nusantara dengan kualitas terbaik.",
        status: "COMING SOON",
        highlights: ['Uang Kertas', 'Silver Coin', 'Certified Paper Money'],
        catalogLink: 'https://bid.syailendra-auction.com/auctions/5-277Y6K/syailendra-auction-complete-19',
        termsLink: '/terms'
    },
    {
        id: 2,
        title: "MUST HAVE #19",
        date: new Date(2026, 0, 9, 19, 0),
        image: musthave,
        
        subtitle: "98 Lot Tjiamik🔥",
        featuring: "Wajib punya bagi kolektor!",
        
        description: "Must Have #19! Item langka yang wajib dimiliki.",
        status: "COMING SOON",
        highlights: ['Uang Kertas', 'Silver Coin', 'Certified Paper Money'],
        catalogLink: 'https://bid.syailendra-auction.com/auctions/5-277Y6R/syailendra-auction-must-have-19',
        termsLink: '/terms'
    },
    {
        id: 3,
        title: "PRESTIGE #19",
        date: new Date(2026, 0, 11, 19, 0),
        image: prestige,
        
        subtitle: "49 Lot Tjiamik Abiez🔥",
        featuring: "Don't miss it!",
        
        description: "Prestige #19! Koleksi paling prestisius bulan ini.",
        status: "COMING SOON",
        highlights: ['Uang Kertas', 'Silver Coin', 'Certified Paper Money'],
        catalogLink: 'https://bid.syailendra-auction.com/auctions/5-279QDV/syailendra-auction-prestige-19',
        termsLink: '/terms'
    }
];